import React from "react"
import Header from "@nvdb-rapport/shared/src/components/Header"
import InfoBanner from "@nvdb-rapport/shared/src/components/InfoBanner"

import "@nvdb-rapport/shared/src/styled/global/reset.css"
import "@nvdb-rapport/shared/src/styled/global/global.css"
import styled from "@emotion/styled"
import * as color from "@nvdb-rapport/shared/src/color"

interface LayoutProps {
  children: React.ReactNode;
  location: Location;
}

export default function Layout({ children, location }: LayoutProps) {
  const pathName = location.pathname
  return (
    <>
      <Header title="Vegnett og objektdata for driftskontrakter" />
      <InfoBanner />
      <Nav pathName={pathName} />
      {children}
    </>
  )
}

function Nav({ pathName }: { pathName: string }) {
  return (
    <nav>
      <NavList>
        <StyledNavLink href="/" className={pathName === "/" ? "selected" : ""}>
          <li>Driftskontrakter</li>
        </StyledNavLink>

        <StyledNavLink
          href="/generisk"
          className={pathName === "/generisk" ? "selected" : ""}
        >
          <li>Egendefinerte rapporter</li>
        </StyledNavLink>
      </NavList>
    </nav>
  )
}

const NavList = styled.ul`
  display: flex;
  justify-content: center;
  list-style: none;
  background-color: lightgrey;
  border-top: 1px solid var(--brand-color);
  border-bottom: 1px solid var(--brand-color);
`

const StyledNavLink = styled.a`
  text-decoration: none;
  color: black;
  transition: all 100ms ease-in-out;

  padding: 1.2rem;
  width: 300px;
  text-align: center;
  border-left: 1px solid var(--brand-color);

  &:last-child {
    border-right: 1px solid var(--brand-color);
  }

  &.selected {
    background-color: ${color.gray600};
    color: ${color.gray100};
  }
  &:hover {
    background-color: ${color.gray500};
    color: white;
  }
`
